import { useState, useEffect } from "react";

const Snackbar = () => {
  const [messageState, setMessageState] = useState("");
  const [severityState, setSeverityState] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleShow = (severity, message) => {
    setSeverityState(severity);
    setMessageState(message);
    setOpenSnackbar(true);
  }
  const handleClose = () => {
    setSeverityState("");
    setMessageState("");
    setOpenSnackbar(false);
  }

  return { message: messageState, severity: severityState, openSnackbar, handleShow, handleClose };
};

export default Snackbar;